import { forwardRef } from "react";
import IconPrint from "../icons/IconPrint";
import { IButtonProps } from "../../interfaces/types";

const ButtonPrint = forwardRef(
  (
    props: IButtonProps,
    ref: React.LegacyRef<HTMLButtonElement> | undefined,
  ) => {
    const { ...rest } = props;
    return (
      <button
        onClick={() => window.print()}
        {...rest}
        className="btn btn-sm btn-outline-primary-subtle d-flex align-items-center gap-2 py-1 px-3"
        title="Udskriv"
        ref={ref}
      >
        <IconPrint />
        <span>Udskriv</span>
      </button>
    );
  },
);

export default ButtonPrint;
